import { deviceId as localDeviceId } from '@/lib/device';
import { useAuth } from './store';

/**
 * Two ids name this browser. The local one (`lib/device.ts`) exists from the first launch and keys the clock; the
 * server's is issued at sign-in and is what the account's device list, and so every other device, knows it by.
 * Comparing one against the other is how a single signed-in browser came to read "Running on another device" (TW-4).
 */

/** What a run started here is stamped with: the server's id when signed in, so other devices can name it. */
export const timerDeviceId = () => useAuth.getState().deviceId ?? localDeviceId();

/** Whether a run was started here, by either id: a run begun before signing in carries the local one. */
export const isThisDevice = (startedOn: string | null, signedInAs: string | null = useAuth.getState().deviceId) =>
  !!startedOn && (startedOn === localDeviceId() || startedOn === signedInAs);
